/**
 * Automy.Core.Enums.Reporting.Filters.ReportDataFilterDimension
 * Power BI session JSON `dimension` (string token).
 */
export default Object.freeze({
  User: 'user',
  Position: 'position',
  UserCompany: 'user-company',
  UserEnvironment: 'user-environment',
  Area: 'area',
  UserGroup: 'user-group',
  DynamicEntity: 'dynamic-entity',
});
